import { ClientEntityDetailsAllocationsQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import SuitabilityDetails, { SuitabilityWrapper } from '@/components/dealCatalog-page/allocator-page/table/cell/suitabilityDetails';
import { AnchorPopover } from '@/components/table/anchor-drop-down';
import DropdownActions from '@/components/table/dropdownActions';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { getUTCDate } from '@/shared/utils/date';
import guid from '@/shared/utils/guid';
import { allocationsTableColumns } from '../constants';
import Suitability from './suitability';

interface AllocationsTableBodyProps {
  tableRows: ClientEntityDetailsAllocationsQuery['ClientEntityDetailsAllocations']['allocations'];
  openModalWindow: (type: string, row: ClientEntityDetailsAllocationsQuery['ClientEntityDetailsAllocations']['allocations'][number]) => void;
  openOpportunityDetailsPage: (id: string) => void;
  getRowStatusText: (status: string) => string;
}

const AllocationsTableBody = ({ tableRows, openModalWindow, openOpportunityDetailsPage, getRowStatusText }: AllocationsTableBodyProps) => {
  if (!tableRows?.length) {
    return <NoResults />;
  }

  return (
    <>
      {tableRows.map((row) => (
        <TableRowWrapper key={guid()}>
          <TableRowCell width={allocationsTableColumns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openOpportunityDetailsPage(row.investmentId)}>
              {row.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={allocationsTableColumns[1].width}>
            <TextCell>{getRowStatusText(row.status)}</TextCell>
          </TableRowCell>
          <TableRowCell width={allocationsTableColumns[2].width}>
            <TextCell>{row.subAssetClass ? `${row.assetClass?.name} - ${row.subAssetClass.name}` : row.assetClass?.name}</TextCell>
          </TableRowCell>
          <TableRowCell width={allocationsTableColumns[3].width}>
            {row.investorDocsDue && <TextCell>{getUTCDate(new Date(row.investorDocsDue))}</TextCell>}
          </TableRowCell>
          <TableRowCell width={allocationsTableColumns[4].width}>
            <TextCell>
              <FormattingTooltip>{row.minimum}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={allocationsTableColumns[5].width}>
            <AnchorPopover
              showLeft
              rowBody={
                <SuitabilityWrapper>
                  <Suitability suitability={row.suitability === 'Suitable' ? 'Meets Criteria' : row.suitability} width="80" />
                </SuitabilityWrapper>
              }
              title={row.suitability === 'Suitable' ? 'Meets Criteria' : row.suitability}
            >
              <SuitabilityDetails data={row?.suitabilityCriteria || []} key={guid()} />
            </AnchorPopover>
          </TableRowCell>
          <TableRowCell width={allocationsTableColumns[6].width}>
            {!['Outstanding', 'Investment review', 'Advisor review', 'Compliance review'].includes(row.status) && (
              <DropdownActions
                items={[
                  {
                    name: 'Begin Allocation',
                    onClick: () => openModalWindow('edit-amount', row)
                  }
                ]}
              />
            )}
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};

export default AllocationsTableBody;
